import { Link } from "react-router-dom";
import { useState } from "react";
import heading from "../images/dawc-heading.svg";
import "../styles/header.css";

const navItems = [
  { to: "/about", label: "About" },
  { to: "/detroit-divest", label: "Detroit Divest" },
  { to: "/zines", label: "Zines" },
];

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="site-header-root">
      <div className="site-header">
        <Link
          to="/"
          className="site-header__home"
          aria-label="Detroit Anti-War Committee — home"
          onClick={closeMenu}
        >
          <img className="site-header__heading" src={heading} alt="Detroit Anti-War Committee" />
        </Link>

        {/* Desktop-only: pinned to the right of the bar */}
        <Link to="/join-us" className="join-button join-button--header" onClick={closeMenu}>
          Get Involved
        </Link>

        {/* Mobile-only (≤750px): toggles the panel below */}
        <button
          type="button"
          className={`menu-toggle${menuOpen ? " menu-toggle--open" : ""}`}
          aria-label={menuOpen ? "Close menu" : "Open menu"}
          aria-expanded={menuOpen}
          aria-controls="mobile-menu"
          onClick={() => setMenuOpen((o) => !o)}
        >
          <span className="menu-toggle__bar" />
          <span className="menu-toggle__bar" />
          <span className="menu-toggle__bar" />
        </button>
      </div>

      {/* Desktop nav bar — collapses on scroll down, expands on scroll up */}
      <nav className="site-nav" aria-label="Primary">
        {navItems.map((item) => (
          <Link key={item.to} to={item.to} className="site-nav__link" onClick={closeMenu}>
            {item.label}
          </Link>
        ))}
      </nav>

      {/* Mobile dropdown panel: nav links + Get Involved */}
      <div id="mobile-menu" className={`mobile-menu${menuOpen ? " mobile-menu--open" : ""}`}>
        {navItems.map((item) => (
          <Link key={item.to} to={item.to} className="mobile-menu__link" onClick={closeMenu}>
            {item.label}
          </Link>
        ))}
        <Link to="/join-us" className="join-button" onClick={closeMenu}>
          Get Involved
        </Link>
      </div>
    </header>
  );
}

export default Header;
